import React, { useState } from 'react';
import {
  Box, Button, CircularProgress, Typography,
} from '@mui/material';
import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import useRUMView from 'common-datadog/useRUMView';
import DealerInfo from '../DealerInfo';
import VehicleInfo from '../VehicleInfo';
import RepairFinder from '../RepairFinder';
import usePrequalUpdate from '../../resources/prequal/usePrequalUpdate';

const RepairInfo = () => {
  useRUMView('repair');

  const {
    handleSubmit,
    isSubmitting,
    control,
    resetField,
    watch,
    setValue,
  } = useSWRMutationForm({
    useMutation: usePrequalUpdate,
    formOptions: {
      defaultValues: {
        vehicleType: 'automobile',
      },
    },
    useUnhandledError: useErrorToSnackbar,
  });

  const [showRepairFinder, setShowRepairFinder] = useState(false);

  const confirmSelectedDealership = (dealershipId) => {
    setValue('merchantId', dealershipId.toString());
    setShowRepairFinder(false);
  };

  if (showRepairFinder) {
    return (
      <RepairFinder
        confirmSelectedDealership={confirmSelectedDealership}
        setShowRepairFinder={setShowRepairFinder}
      />
    );
  }

  return (
    <Box component="form" sx={{ display: 'flex', flexDirection: 'column', rowGap: '16px' }} onSubmit={handleSubmit}>
      <DealerInfo
        control={control}
        selectedMerchantId={watch('merchantId')}
        onMerchantChange={() => resetField('advisorId')}
        onShowRepairFinder={() => setShowRepairFinder(true)}
      />
      <VehicleInfo
        control={control}
        vehicleType={watch('vehicleType')}
      />
      <Typography variant="caption">
        By clicking “See If I Prequalify,” you agree to provide true and accurate information.
        You understand that your U.S. legal resident status will be verified, and you may be asked
        to provide supporting documentation. If you can&apos;t provide this, your prequalification
        will not be accepted. You authorize DigniFi and WebBank to conduct a soft credit check for
        prequalification purposes and verify the information provided. Verification may involve
        third parties associated with the credit application process, as well as individuals
        authorized by law. You acknowledge that, upon approval, all documents must be signed within
        30 days for your financing offer to remain valid. Continuing will not impact your credit
        score.
      </Typography>
      <Button
        fullWidth
        type="submit"
        disabled={isSubmitting}
        startIcon={isSubmitting && <CircularProgress size={18} sx={{ color: '#FFFFFF' }} />}
        sx={{ my: '16px' }}
      >
        See If I Prequalify
      </Button>
    </Box>
  );
};

export default RepairInfo;
